import React, {useState, useEffect, useRef} from 'react';

import * as S from './OtpVerifyUI.styles';
import * as C from '../Common.styles';

import IconSelector from '@ibibo/icon-selector';
import {sendEvarData} from '@ibibo/analytics';
import {validations} from '../../../../utils/validations';
import {maskEmail, maskMobile} from '../../../../utils/utils';
import ButtonLoader from '../../UI/Loader/Loader';
import {NON_EDITABLE_STATUS} from '../../../../constants';
import OTPBlock from '../../UI/OTP/otp';

const OtpVerifyUI = ({
  onOTPSubmit,
  editField,
  resendOTP,
  email,
  mobile,
  apiError,
  setLoader,
  status,
  mobile_count,
  email_count,
}) => {
  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const mobileOtpRef = useRef(null);
  const emailOtpRef = useRef(null);

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  const fieldValidators = {
    mobile_otp: {
      field: 'mobile_otp',
      fieldName: 'Mobile OTP',
      validators: ['required', 'numeric', 'fixedLength'],
    },
    email_otp: {
      field: 'email_otp',
      fieldName: 'Email OTP',
      validators: ['required', 'numeric', 'fixedLength'],
    },
  };

  const fieldName = {
    email: {
      name: 'Email',
      value: email,
    },
    mobile: {
      name: 'Mobile',
      value: mobile,
    },
  };

  const mobileOtpLen = 6;
  const emailOtpLen = 4;

  const validateFields = data => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            length: key === 'email_otp' ? emailOtpLen : mobileOtpLen,
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const verifyOTP = event => {
    event.preventDefault();

    const mOTPStr = mobileOtpRef.current.value;
    const eOTPStr = emailOtpRef.current.value;

    const data = {
      mobile_otp: mOTPStr,
      email_otp: eOTPStr,
    };

    let hasError = false;
    if (NON_EDITABLE_STATUS.indexOf(status) === -1) {
      hasError = validateFields(data);
    }
    if (!hasError) {
      onOTPSubmit(data);
    }
    // sendEvarData({
    //   prop54: "myPartner|signup|OTPVerification|next"
    // }, true)
  };

  const maskField = (field, value) => {
    switch (field) {
      case 'email':
        return maskEmail(value);
      case 'mobile':
        return maskMobile(value);
    }
  };

  const DetailBlock = ({field}) => (
    <S.OtpEmailInnerWrap>
      <S.OtpEditIconWrap>
        {field === 'email' ? <IconSelector iconKey='emailotp' /> : <IconSelector iconKey='mobileotp' />}
      </S.OtpEditIconWrap>
      <S.OtpEditTextWrap>
        <S.OtpEditHeadText>{fieldName[field].name}:</S.OtpEditHeadText>
        <S.OtpEditSubText>
          {maskField(field, fieldName[field].value)}
          <S.OtpEditText onClick={() => editField(field)}>(Edit)</S.OtpEditText>
        </S.OtpEditSubText>
      </S.OtpEditTextWrap>
    </S.OtpEmailInnerWrap>
  );

  return (
    <C.FormMainWrapper>
      <C.WelcomeHeadText>Verify details</C.WelcomeHeadText>
      <C.HeadSubText>Please enter the 2 unique OTPs sent to: </C.HeadSubText>
      <S.OtpEditWrapper>
        <DetailBlock field="email" />
        <DetailBlock field="mobile" />
      </S.OtpEditWrapper>
      <C.FormWrapper>
        <C.UserInfoForm onSubmit={verifyOTP}>
          <C.BlockWrapper disabled={NON_EDITABLE_STATUS.indexOf(status) !== -1}>
            <S.OtpInputOuterWrapper>
              <OTPBlock
                ref={mobileOtpRef}
                label="Mobile otp"
                subLabel=""
                otpLength={mobileOtpLen}
                type="motp"
                error={errors['mobile_otp']}
                resendOTP={resendOTP}
                autoFocus={true}
                resendVisible={mobile_count}
              />
              <OTPBlock
                ref={emailOtpRef}
                label="Email otp"
                subLabel=""
                otpLength={emailOtpLen}
                type="eotp"
                error={errors['email_otp']}
                resendOTP={resendOTP}
                autoFocus={false}
                resendVisible={email_count}
              />
            </S.OtpInputOuterWrapper>
            <C.ApiErrorText>
              {apiErrorMsg && apiErrorMsg.screen === 'verify' ? apiErrorMsg.msg : ''}
            </C.ApiErrorText>
          </C.BlockWrapper>

          <C.ButtonWrapper>
            <C.SignUpBtn type="submit">
              {setLoader ? <ButtonLoader loaderType="button" /> : 'NEXT'}
            </C.SignUpBtn>
          </C.ButtonWrapper>
        </C.UserInfoForm>
      </C.FormWrapper>
    </C.FormMainWrapper>
  );
};

export default OtpVerifyUI;
